import types from '../actionTypes';

const initialState = {
	mobileActive: false,
	activeSections: [],
	loadingSections: [],
	levels: [],
	subjects: {},
	topics: [],
	classes: {},
	taskTypes: [],
	difficulties: [],
	selected: {
		level: null,
		subjects: [],
		topics: [],
		classes: [],
		// taskType: null,
		// difficulty: []
	},
};

function filterReducer(state = initialState, action) {
	switch (action.type) {
		case types.CLOSE_FILTER:
			return {
				...state,
				mobileActive: false,
			};
		case types.OPEN_FILTER:
			return {
				...state,
				mobileActive: true,
			};
		case types.GET_FILTER_LEVELS:
			return {
				...state,
				levels: action.payload,
			};
		case types.GET_FILTER_CLASSES:
			return {
				...state,
				classes: action.payload,
			};
		case types.GET_FILTER_SUBJECTS:
			return {
				...state,
				subjects: action.payload,
			};
		case types.GET_FILTER_TOPICS:
			return {
				...state,
				topics: action.payload,
			};
		case types.GET_FILTER_TASKTYPES:
			return {
				...state,
				taskTypes: action.payload,
			};
		case types.GET_FILTER_DIFFICULTIES:
			return {
				...state,
				difficulties: action.payload,
			};
		// case types.GET_FILTER_DATA:
		//     return {
		//         ...state,
		//         ...action.data
		//     }

		/* TODO: Rebuild toggle_section fn */
		case types.TOGGLE_FILTER_SECTIONS:
			const activeSections = (() => {
				if (action.section === 'level') {
					if (state.activeSections.indexOf(action.section) === -1) {
						return [...state.activeSections.filter((section) => section !== 'subject'), 'level'];
					} else {
						return state.activeSections.filter((section) => section !== action.section);
					}
				} else if (action.section === 'subject') {
					if (state.activeSections.indexOf(action.section) === -1) {
						return [...state.activeSections.filter((section) => section !== 'level'), 'subject'];
					} else {
						return state.activeSections.filter((section) => section !== action.section);
					}
				} else {
					if (state.activeSections.indexOf(action.section) === -1) {
						return [...state.activeSections, action.section];
					} else {
						return state.activeSections.filter((section) => section !== action.section);
					}
				}
			})();
			return {
				...state,
				activeSections: activeSections,
			};
		case types.COLLAPSE_FILTER_SECTIONS:
			return {
				...state,
				activeSections: initialState.activeSections,
			};
		case types.SET_FILTER_SECTIONS_LOADING:
			return {
				...state,
				loadingSections: action.status
					? [...state.loadingSections, action.section]
					: state.loadingSections.filter((section) => section !== action.section),
			};
		case types.SET_ALL_FILTERS:
			const { level, subjects, topics, classes, taskType, difficulty } = action.filters;
			return {
				...state,
				selected: {
					level,
					classes,
					subjects,
					topics,
					taskType,
					difficulty,
				},
			};
		case types.SET_FILTER_LEVEL:
			return {
				...state,
				selected: {
					...state.selected,
					level: action.levelID,
				},
			};
		case types.SET_FILTER_CLASS:
			return {
				...state,
				selected: {
					...state.selected,
					classes: state.selected.classes.includes(action.classID)
						? state.selected.classes.filter((single) => single !== action.classID)
						: [...state.selected.classes, action.classID],
				},
			};
		case types.SET_FILTER_SUBJECT:
			return {
				...state,
				selected: {
					...state.selected,
					subjects: state.selected.subjects.includes(action.subjectID)
						? state.selected.subjects.filter((single) => single !== action.subjectID)
						: [...state.selected.subjects, action.subjectID],
				},
			};
		case types.SET_FILTER_TOPIC:
			return {
				...state,
				selected: {
					...state.selected,
					topics: state.selected.topics.includes(action.topicID)
						? state.selected.topics.filter((single) => single !== action.topicID)
						: [...state.selected.topics, action.topicID],
				},
			};
		case types.SET_FILTER_TASKTYPE:
			return {
				...state,
				selected: {
					...state.selected,
					taskType: action.taskTypeID,
				},
			};
		case types.SET_FILTER_DIFFICULTY:
			return {
				...state,
				selected: {
					...state.selected,
					difficulty: state.selected.difficulty.includes(action.difficultyID)
						? state.selected.difficulty.filter((single) => single !== action.difficultyID)
						: [...state.selected.difficulty, action.difficultyID],
				},
			};
		case types.RESET_FILTER_CLASSES:
			return {
				...state,
				selected: {
					...state.selected,
					classes: [],
				},
			};
		case types.RESET_FILTER_SUBJECTS:
			return {
				...state,
				selected: {
					...state.selected,
					subjects: [],
				},
			};
		case types.RESET_FILTER_TOPICS:
			return {
				...state,
				selected: {
					...state.selected,
					topics: [],
				},
			};
		case types.RESET_FILTER_TASKTYPE:
			return {
				...state,
				selected: {
					...state.selected,
					taskType: 3,
				},
			};
		default:
			return state;
	}
}

export default filterReducer;
